import React from 'react';
import { Box } from '@mui/material';
import { Device } from '../interfaces/Device';
import { getDeviceImage, getDeviceImageFromMenu, DeviceImageInfo } from '../utils/deviceImages';

interface DeviceImageProps {
  device: Device;
  alarmProfiles?: any;
  size?: 'small' | 'medium' | 'large';
  showFallback?: boolean;
}

const DeviceImage: React.FC<DeviceImageProps> = ({ 
  device, 
  alarmProfiles, 
  size = 'small',
  showFallback = true 
}) => {
  const sizeMap = {
    small: { width: 48, height: 48 },
    medium: { width: 32, height: 32 },
    large: { width: 202, height: 202 }
  };

  const dimensions = sizeMap[size];

  // Get device image info
  const imageInfo: DeviceImageInfo = alarmProfiles 
    ? getDeviceImageFromMenu(alarmProfiles, device.device_type, device.device_model)
    : getDeviceImage(device.device_model);
  console.log (device)
  // If no image source and not showing fallback, return null
  if (!imageInfo.src && !showFallback) {
    return null;
  }

  // Show fallback icon if no image
  if (!imageInfo.src) {
    return (
      <Box
        sx={{
          width: dimensions.width,
          height: dimensions.height,
          backgroundColor: 'grey.300',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          color: 'grey.600',
          minWidth: dimensions.width,
          flexShrink: 0,
        }}
      >
        📱
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: dimensions.width,
        height: dimensions.height,
        minWidth: dimensions.width,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={imageInfo.src}
        alt={imageInfo.alt}
        style={{
          width: dimensions.width,
          height: dimensions.height,
          objectFit: 'contain',
        }}
        onError={(e) => {
          // Fallback to emoji icon if image fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const fallbackBox = target.parentElement;
          if (fallbackBox) {
            fallbackBox.innerHTML = '📱';
            fallbackBox.style.backgroundColor = '#e0e0e0';
            fallbackBox.style.borderRadius = '4px';
            fallbackBox.style.display = 'flex';
            fallbackBox.style.alignItems = 'center';
            fallbackBox.style.justifyContent = 'center';
            fallbackBox.style.fontSize = '12px';
            fallbackBox.style.color = '#666';
          }
        }}
      />
    </Box>
  );
};

export default DeviceImage;